import React from 'react';
import {
  auth,
  db,
  storage,
  googleProvider,
  facebookProvider,
  twitterProvider,
  githubProvider,
} from './firebase'; // Adjust the import path

const FirebaseContext = React.createContext(null);

const firebaseServices = {
  auth,
  db,
  storage,
  googleProvider,
  facebookProvider,
  twitterProvider,
  githubProvider,
};

export const withFirebase = (Component) => (props) => (
  <FirebaseContext.Provider value={firebaseServices}>
    <Component {...props} firebase={firebaseServices}/>
  </FirebaseContext.Provider>
);

export { firebaseServices }; // Add this export for firebaseServices
export default FirebaseContext;
